import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TabLinks from "../../../../components/Common/TabLinks/TabLinks";
import { getTenantPollUsersHandler } from "../../../../store/actions/actionHandlers/socialActionHandler";
import classes from "./DistributePoll.module.scss";
import DistributePollForm from "./DistributePollForm/DistributePollForm";
import PollUsers from "./DistributePollTabs/DistributePollTabs";
import { FormattedMessage } from "react-intl";

const DistributePoll = ({ pollId, setisDistibuteModal }) => {
  const dispatch = useDispatch();
  const [activeTab, setactiveTab] = useState(1);
  const [usersData, setUsersData] = useState(null);
  const socialState = useSelector((state) => state.socialReducer);
  const { pollPreviewList } = socialState;
  let contentTabs = [
    {
      id: 1,
      name: <FormattedMessage id="DIST_HIST_USERS" />,
      heading: "Users",
    },
    {
      id: 2,
      name: <FormattedMessage id="DIST_HIST_USER_GRP" />,
      heading: "User Groups",
    },
    {
      id: 3,
      name: <FormattedMessage id="P_PREVIEW_LIST" />,
      heading: "Preview List",
    },
  ];

  useEffect(() => {
    dispatch(getTenantPollUsersHandler(false, pollPreviewList));
  }, [dispatch]);

  return (
    <div className={classes.distributePoll}>
      <div className={classes.upperArea}>
        <DistributePollForm
          activeTab={activeTab}
          pollId={pollId}
          setisDistibuteModal={setisDistibuteModal}
        />
      </div>
      <div className={classes.usersTable}>
        <TabLinks
          tabs={contentTabs}
          activeTab={activeTab}
          setActiveTab={setactiveTab}
        />
        <div className={classes.tabContent}>
          <PollUsers
            activeTab={activeTab}
            usersData={usersData}
            setUsersData={setUsersData}
          />
        </div>
      </div>
    </div>
  );
};

export default DistributePoll;
